import { AnticipationFeeData } from "../types";
import { bffApi } from "../../../../../services/bff/bffApi";
import {BaseService} from "../../../../../global/classes";

export default class AnticipationFeeService extends BaseService {
  getAnticipationFees = async () => {
    try {
      const response = await bffApi.get(
        `/api/gcb/v1/anticipationfee/get-anticipation-fee`
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  };

  postInsertAnticipationFees = async (
    newAnticipationFee: AnticipationFeeData
  ) => {
    const userInfo: string | null = localStorage.getItem("userInfo");
    let parserdEmail = null;
    if (userInfo) parserdEmail = JSON.parse(userInfo);

    const email = parserdEmail.email || null;

    try {
      const response = await bffApi.post(
        `/api/gcb/v1/anticipationfee/post-anticipation-fee`,
        {
          adValorem: newAnticipationFee.adValorem,
          dailyIof: newAnticipationFee.dailyIof,
          additionalIof: newAnticipationFee.additionalIof,
          operationFee: newAnticipationFee.operationFee,
          createdBy: email,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };
}
